import React from 'react'
import './App.css'
import Users from './components/users'

const App = () => {
  return (
    <div className='App'>
      <Users />
    </div>
  )
}

export default App
